// src/Hooks/useDeleteMobile.js
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { showSnackbar } from '../Reducer/SnackbarReducer';
import useActionLog from './useActionLog';
import { closeLoading, showLoading } from '../Reducer/LoadingReducer';

export function useDelete({
  menuId,
  getDeletedRows,
  requestDelete,
  fileDelete = null,
  afterDeleteRow = null,
  onSuccess = null,
}) {
  const dispatch = useDispatch();
  const { userInfo } = useSelector((state) => state.BaseInfo);
  const [detailData, setDetailData] = useState(null);

  const { SaveActionLog } = useActionLog();

  const run = async (params) => {
    dispatch(showLoading());

    const deletedRows = params
      ? Array.isArray(params)
        ? params
        : [params]
      : [].concat(getDeletedRows?.() || []);

    try {
      const deleteResponse = await requestDelete?.(deletedRows);

      let deleteDetailData = [];
      if (Array.isArray(deleteResponse)) deleteDetailData = deleteResponse;
      else if (deleteResponse?.data && Array.isArray(deleteResponse.data))
        deleteDetailData = deleteResponse.data;

      setDetailData(deleteDetailData.length ? deleteDetailData : null);

      if (fileDelete) await fileDelete(deletedRows);

      if (afterDeleteRow) {
        for (let idx = 0; idx < deletedRows.length; idx++) {
          await afterDeleteRow(deletedRows[idx], {
            index: idx,
            savedRows: deleteDetailData,
            userInfo,
          });
        }
      }

      const hasFailure = (deleteDetailData ?? []).some(
        (r) => r.isSuccess === false
      );
      if (hasFailure) {
        dispatch(
          showSnackbar({
            message: '오류가 발생했습니다. 잠시 후 다시 시도해주세요.',
            type: 'error',
          })
        );
      } else {
        dispatch(showSnackbar({ message: '삭제되었습니다.', type: 'success' }));
      }

      await onSuccess?.({ deleteDetailData, deletedRows, userInfo });

      await SaveActionLog(deletedRows, {
        menuId,
        coCd: userInfo.authCd === 'ADMIN' ? '' : userInfo.coCd,
        userId: userInfo.userid,
        logResult: hasFailure ? 'ERROR' : 'SUCCESS',
      });
    } catch (e) {
      if (e?.shouldShowDialog) return;
      dispatch(
        showSnackbar({
          message:
            e?.message || '오류가 발생했습니다. 잠시 후 다시 시도해주세요.',
          type: 'error',
        })
      );
      await SaveActionLog(deletedRows, {
        menuId,
        coCd: userInfo.authCd === 'ADMIN' ? '' : userInfo.coCd,
        userId: userInfo.userid,
        logResult: 'ERROR',
        errorMsg: e?.message,
      });
    } finally {
      dispatch(closeLoading());
    }
  };

  return { run, detailData };
}
